import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { colors } from '../theme';

const links = [
  { label: 'About', id: 'about' },
  { label: 'Market Hours', id: 'market-hours' },
  { label: 'Contact', id: 'contact' },
];

const Wordmark = ({ onClick }) => (
  <Box
    component="button"
    onClick={onClick}
    sx={{
      border: 0,
      background: 'none',
      cursor: 'pointer',
      p: 0,
      fontWeight: 600,
      fontSize: '1.05rem',
      letterSpacing: '-0.01em',
      color: colors.ink,
      fontFamily: 'inherit',
    }}
  >
    Adrian&nbsp;Chesnoiu
  </Box>
);

function Shell({ children }) {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        top: 0,
        backgroundColor: 'rgba(255,255,255,0.72)',
        backdropFilter: 'saturate(180%) blur(20px)',
        WebkitBackdropFilter: 'saturate(180%) blur(20px)',
        borderBottom: `1px solid ${colors.grayBorder}`,
        color: colors.ink,
      }}
    >
      <Container>
        <Toolbar disableGutters sx={{ minHeight: { xs: 52, md: 56 }, justifyContent: 'space-between' }}>
          {children}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default function Nav() {
  const [open, setOpen] = React.useState(false);

  const goTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const goTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <Shell>
      <Wordmark onClick={goTop} />

      <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
        {links.map((l) => (
          <Button
            key={l.id}
            onClick={() => goTo(l.id)}
            sx={{
              color: colors.inkSoft,
              fontSize: '0.95rem',
              fontWeight: 400,
              '&:hover': { color: colors.ink, background: 'transparent' },
            }}
          >
            {l.label}
          </Button>
        ))}
      </Box>

      <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
        <IconButton onClick={() => setOpen(true)} sx={{ color: colors.ink }} aria-label="menu">
          <MenuIcon />
        </IconButton>
        <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
          <Box sx={{ width: '68vw', maxWidth: 320, pt: 6 }}>
            <List>
              {links.map((l) => (
                <ListItemButton key={l.id} onClick={() => goTo(l.id)}>
                  <ListItemText primary={l.label} primaryTypographyProps={{ fontSize: '1.15rem' }} />
                </ListItemButton>
              ))}
            </List>
          </Box>
        </Drawer>
      </Box>
    </Shell>
  );
}

export function BackNav() {
  return (
    <Shell>
      <Button
        href="/"
        startIcon={<ArrowBackIosNewRoundedIcon sx={{ fontSize: '0.9rem' }} />}
        sx={{ color: colors.ink, fontWeight: 400, '&:hover': { background: 'transparent', color: colors.blue } }}
      >
        Back
      </Button>
      <Wordmark onClick={() => { window.location.href = '/'; }} />
      <Box sx={{ width: 64 }} />
    </Shell>
  );
}
